import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user custom-scroll",
  "element-loading-background": "rgba(255,255,255,.3)"
};
const _hoisted_2 = {
  class: "inner"
};
const _hoisted_3 = {
  class: "user-profile"
};
const _hoisted_4 = {
  class: "absolute -right-[50px] top-0 h-full flex items-center"
};
const _hoisted_5 = {
  class: "absolute -right-[50px] top-0 h-full flex items-center"
};
import { onMounted, ref } from "vue";
import { checkSession } from "@/store/cache";
import UserProfile from "@/components/UserProfile.vue";
import PasswordDialog from "@/components/PasswordDialog.vue";
import BindMobile from "@/components/BindMobile.vue";
import { useSharedStore } from "@/store/sharedata";
import BindEmail from "@/components/BindEmail.vue";
import ThirdLogin from "@/components/ThirdLogin.vue";
import { ElMessage } from "element-plus";
import { httpGet } from "@/utils/http";
export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfileSetting',
  setup(__props) {
    const showPasswordDialog = ref(false);
    const showBindMobileDialog = ref(false);
    const showBindEmailDialog = ref(false);
    const showThirdLoginDialog = ref(false);
    const user = ref();
    const isLogin = ref(false);
    const store = useSharedStore();
    const profileKey = ref(0);
    async function loadUser() {
      if (!isLogin.value) {
        return;
      }
      httpGet("/system/user/profile/session").then(res => {
        user.value = res;
      }).catch(e => {
        ElMessage.error("获取用户信息失败：" + e.message);
      });
    }
    onMounted(() => {
      checkSession().then(async _user => {
        isLogin.value = true;
        await loadUser();
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(UserProfile, {
        key: profileKey.value
      })), _createVNode(_component_el_form, {
        model: user.value,
        "label-width": "80px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "手机号码",
          class: "relative w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: true,
            value: user.value?.mobile
          }, null, 8, ["value"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tooltip, {
            content: "绑定手机号码",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              text: "",
              size: "small",
              dark: false,
              type: "primary",
              onClick: _cache[0] || (_cache[0] = $event => showBindMobileDialog.value = true)
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 绑定 ")])),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "邮箱地址",
          class: "relative w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            disabled: true,
            value: user.value?.email
          }, null, 8, ["value"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tooltip, {
            content: "绑定邮箱，后续支持此功能",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              text: "",
              size: "small",
              dark: false,
              type: "primary",
              disabled: true,
              onClick: _cache[1] || (_cache[1] = $event => showBindEmailDialog.value = true)
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" 绑定 ")])),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        class: "user-opt",
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = $event => showPasswordDialog.value = true)
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("修改密码")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])]), isLogin.value ? (_openBlock(), _createBlock(PasswordDialog, {
        key: 0,
        show: showPasswordDialog.value,
        onHide: _cache[3] || (_cache[3] = $event => showPasswordDialog.value = false)
      }, null, 8, ["show"])) : _createCommentVNode("", true), isLogin.value ? (_openBlock(), _createBlock(BindMobile, {
        key: 1,
        oldMobile: user.value?.mobile,
        show: showBindMobileDialog.value,
        onHide: _cache[4] || (_cache[4] = $event => showBindMobileDialog.value = false)
      }, null, 8, ["oldMobile", "show"])) : _createCommentVNode("", true), isLogin.value ? (_openBlock(), _createBlock(BindEmail, {
        key: 2,
        oldEmail: user.value?.email,
        show: showBindEmailDialog.value,
        onHide: _cache[5] || (_cache[5] = $event => showBindEmailDialog.value = false)
      }, null, 8, ["oldEmail", "show"])) : _createCommentVNode("", true), isLogin.value ? (_openBlock(), _createBlock(ThirdLogin, {
        key: 3,
        show: showThirdLoginDialog.value,
        onHide: _cache[6] || (_cache[6] = $event => showThirdLoginDialog.value = false)
      }, null, 8, ["show"])) : _createCommentVNode("", true)])]);
    };
  }
});